import {
  sportGamesStatusOptions,
  sportStatusOptions,
} from "../sports/shared";

export const teamStatusOptions = sportStatusOptions;
export const teamGamesStatusOptions = sportGamesStatusOptions;
